import common from './common';
import primary from './primary';
import secondary from './secondary';
import product from './product';
import error from './error';
import text from './text';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  common,
  product,
  primary,
  secondary,
  error,
  text,
};
